export default "__VITE_ASSET__gPzmnVVq__"